module.exports = __webpack_public_path__ + "img/car-cover-main.7c5e61d.webp";